import {
    createSelector,
} from '@reduxjs/toolkit';

import {
    selectDisplaySinglesContent,
} from './uiSelectors';
import {
    selectOneCombinationSelectionIds,
} from './combinationsSelectors';

export const selectContingencies = (state) => state.betslip.contingencies;

export const selectHasContingencies = createSelector(
    selectContingencies,
    contingencies => Boolean(contingencies.length > 0),
);

const selectIsContingencySelection = createSelector(
    [
        selectContingencies,
        (_state, selectionId) => selectionId,
        selectOneCombinationSelectionIds,
    ],
    (contingencies, selectionId, combinationSelections) => {
        const singleContingency = contingencies.includes(selectionId);
        if (singleContingency) {

            return true;
        }

        return combinationSelections.some(id => contingencies.includes(String(id)));
    },
);

export const selectShowContingenciesNotification = createSelector(
    [
        selectDisplaySinglesContent,
        selectContingencies,
    ],
    (selectDisplaySinglesContent, contingencies) => !selectDisplaySinglesContent && contingencies.length
);

export const selectShowContingencyMarker = createSelector(
    [
        selectIsContingencySelection,
        selectDisplaySinglesContent,
    ],
    (isContingencySelection, displaySinglesContent) => isContingencySelection && !displaySinglesContent
);
